import { useEffect } from 'react';

export function useDidMount(callback: () => void): void {
  useEffect(() => {
    callback();
  }, []);
}
